"use strict";

window.FoG = window.FoG || {};

window.FoG.Activity = (function($) {
  var $activityContainer;
  var $loadMoreBtn;
  var $activityList;
  
  function onLoadMore(response) {
    var lmDef = FoG.loadMoreActivityDef;
    lmDef.loadingMore = false;

    var $activityTemplate = $activityList.find('li.cloneable');

    // Loop through articles and create/populate/append each one to the list
    $.each(response.activity, function(dummyIdx, activity) {
      var $activity = $activityTemplate.clone().removeClass('cloneable');
      $activity.find('h3').html(activity.actionHtml);
      $activity.find('time').attr('datetime', activity['date-iso']).text(activity['date-display']);
      $activityList.append($activity);
      $activity.addClass('activity--' + activity.activityClass);
    });
    
    lmDef.hasMore = response.hasMore;
    lmDef.nextPage = response.nextPage;

    if (!lmDef.hasMore) {
      $loadMoreBtn.remove();
    }
  }

  
  function loadMore() {
    var lmDef = FoG.loadMoreActivityDef;
    
    if (!lmDef || !lmDef.hasMore) { 
      $loadMoreBtn.remove(); 
      return;
    }

    if (lmDef.loadingMore) { return; }
    lmDef.loadingMore = true;
    
    var params = {
      page: lmDef.nextPage
    }
    
    var fnResetLoadingMore = function() { lmDef.loadingMore = false; }
    
    NA.Ajax.get('load-activity', params, onLoadMore, fnResetLoadingMore);
  }
  
  
  function initLoadMore() {
    $activityContainer = $('.activityContainer');
    $loadMoreBtn = $('.activityContainer__loadMore', $activityContainer);
    $activityList = $('.activityContainer__recentActivityList', $activityContainer);

    $loadMoreBtn.on('click', loadMore);
  }
  
  return {
    initLoadMore: initLoadMore
  };
})(jQuery);